import "core-js/stable";
// import "regenerator-runtime/runtime";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App.tsx";
import store from "./store.js";
import { keepSessionAlive, isLocalhost } from "./utils/utils.js";
import "./css/app.scss";
import { getInitialDataAction } from "./actions/importActions.ts";

if (!isLocalhost()) {
  keepSessionAlive();
}

store.dispatch(getInitialDataAction());

const rootElement = document.getElementById("root");
if (rootElement) {
  const root = createRoot(rootElement);

  root.render(
    <Provider store={store}>
      <div className="spbootstrap">
        <div id="app">
          <App />
        </div>
      </div>
    </Provider>
  );
}
